<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='notaE' :items='notaE' :search='search' sort-by='Numero' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title Notas de Entrega
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
            v-dialog(v-model='dialog' scrollable persistent max-width='80%')
              template(v-slot:activator='{ on }')
                v-btn.mx-2(v-if='validarCrear()' fab dark small color='success' v-on='on')
                  v-icon(dark) mdi-plus
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  v-card-title.headline {{ formTitle }}
                v-divider
                v-card-text
                  v-row(v-if='editedIndex === -1')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='4')
                              v-autocomplete(dense outlined :menu-props="{closeOnContentClick: true}" :readonly='read' v-model='selectC' :items='idClienteArray' label='Cliente' @change="clienteSeleccionado")
                                template(v-slot:prepend-item v-if="validarCrearCli()")
                                  v-list(dense)
                                    v-list-item( @click='emp = true')
                                      v-list-item-avatar(color='grey_1' small)
                                        v-btn.mx-2(fab dark x-small color='success')
                                          v-icon(dark small) mdi-plus
                                      v-list-item-content
                                        v-list-item-title
                                          | Agregar Cliente
                            ClienteM(:dialog='emp' :editedIndex='-1' @close='emp = false' @save='listarClientes')
                            v-col(cols='12' sm='12' md='4')
                              v-select(dense, outlined, :readonly='read' v-model='editedItem.tipoVenta' :items='items' label='Tipo de Venta')
                            v-col(cols='12' sm='12' md='4')
                              v-dialog(ref='dialog2' v-model='modalEmision' :return-value.sync='dateEmision' readonly persistent width='300px')
                                template(v-slot:activator='{ on }')
                                  v-text-field( v-model='editedItem.fechaCreacion' label='Fecha de Creación' prepend-inner-icon='event' readonly dense outlined v-on='on')
                                v-date-picker( v-model='editedItem.fechaCreacion' locale="ES" )
                                  v-spacer
                                  v-btn(small dark color='error' @click='modalEmision = false') Cancelar
                                  v-btn(small dark color='success' @click='$refs.dialog2.save(dateEmision)') Ok
                            v-col(cols='12' sm='12' md='12')
                              v-textarea(outlined dense :readonly='read' v-model='editedItem.observacion' label="Observación" v-uppercase)
                    p
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              ProductosParaVenta(v-if='editedIndex === -1' :read='read' :loading='loadinghijo' :consignado='consignado' :productosParaVenta='productosParaVenta' @agregarAlCarrito='agregarAlCarrito')
                          p
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              ProductosCargados(v-if='editedIndex === -1', :read='read', :productosEnCarrito='editedItem.detalleProducto', @modificarCarrito='modificarCarrito', @quitarCarrito='quitarCarrito')
                  v-row(v-if='editedIndex > -1')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='6' sm='12' md='6')
                              v-text-field(dense outlined readonly v-model='editedItem.idPedido.numeroPedido || null' label='Número de Pedido')
                            v-col(cols='6' sm='12' md='6')
                              v-text-field(dense, outlined, readonly, v-model='cliente', label='Cliente')
                          v-row(dense v-if='!config.campoDiasCreditoCli')
                            v-col(cols='6' sm='12' md='6')
                              v-select(dense outlined v-model='editedItem.tipoVenta' :items='items' label='Tipo de Venta')
                            v-col(cols='12' sm='12' md='6')
                              v-dialog(ref='dialog1', v-model='modalven' :return-value.sync='dateVencimiento' readonly persistent width='300px')
                                template(v-slot:activator='{ on }')
                                  v-text-field( v-model='editedItem.fechaVencimiento' label='Fecha de vencimiento' prepend-inner-icon='event' readonly dense outlined v-on='on')
                                v-date-picker( v-model='editedItem.fechaVencimiento' locale="ES" )
                                  v-spacer
                                  v-btn(small dark color='error' @click='modalven = false') Cancelar
                                  v-btn(small dark color='success' @click='$refs.dialog1.save(dateVencimiento)') Ok
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              v-data-table.elevation-1(v-if='editedIndex > -1' :headers='headers2' :items='editedItem.detalleProducto')
                                template(v-slot:top)
                                  v-toolbar(flat color='primary' dark)
                                    v-toolbar-title.justify-center(color='success') Productos para Facturar
                          v-row(dense)
                            v-row(class='d-flex justify-end')
                              v-col(cols='3' sm='3' md='3')
                                v-text-field(dense readonly outlined :value='editedItem.subTotal | read', label='Subtotal')
                              v-col(cols='3' sm='3' md='3')
                                v-text-field(dense readonly :value='editedItem.gravado | read', outlined label='Gravado')
                              v-col(cols='3' sm='3' md='3')
                                v-text-field(dense readonly :value='editedItem.exento | read', outlined label='Exento')
                              v-col(cols='3' sm='3' md='3')
                                v-text-field(dense readonly :value='editedItem.total | read', outlined label='Total + IVA')
                v-card-actions
                  v-spacer
                  v-btn(color='error' small dark @click='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(v-if='editedIndex === -1' color='success' small dark @click='save')
                    v-icon mdi-content-save
                    | Generar
                  v-btn(v-else color='success' small dark @click='save')
                    v-icon mdi-content-save
                    | Facturar
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item, true)' v-on="on") mdi-eye
            | Visualizar
          v-icon.mr-2(v-if='item.estatus === "generado" ' color='primary_2' @click='editItem(item,false)') mdi-format-list-checkbox
        template(v-slot:no-data)
          h1 No hay notas de entregas asociadas
      Factura(:dialogFactura='dialogFactura' @close = 'closeF' :origen='origen')
</template>

<script>
import Api from '@/services/methods'
import ProductosCargados from '../components/ProductosCargados'
import ProductosParaVenta from '../components/ProductosParaVenta'
import ClienteM from '../components/modals/ClienteM'
import { EventBus } from '../Events'
import Factura from '../components/reportes/Factura'
export default {
  name: 'NotaEntrega',
  data: () => ({
    dialogFactura: false,
    config: {
      campoDiasCreditoCli: null
    },
    origen: '',
    emp: false,
    boton: false,
    consignado: false,
    peticion: false,
    dialog: false,
    modalven: false,
    modalEmision: false,
    dialog1: false,
    dialog2: false,
    dateVencimiento: new Date().toISOString().substr(0, 10),
    dateEmision: new Date().toISOString().substr(0, 10),
    read: false,
    loading: true,
    headers: [
      { text: 'Nro de Nota', value: 'numNotaEntrega' },
      { text: 'Nro de Pedido', value: 'idPedido.numeroPedido' },
      { text: 'Cliente', value: 'idCliente.nombre' },
      { text: 'Fecha de Registro', value: 'fechaCreacion' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    headers2: [
      { text: 'Codigo', value: 'idProducto.nombre' },
      { text: 'Nombre', value: 'idProducto.descripcion' },
      { text: 'Cant. a Facturar', value: 'despachada' },
      // { text: 'Porc. Descuento', value: 'porcDescuento' },
      { text: 'Precio', value: 'precio' },
      { text: 'Sub Total', value: 'subTotal' },
      { text: 'Monto Total', value: 'total' }
      // { text: "Acciones", value: "action", align: "right", sortable: false }
    ],
    search: '',
    loadinghijo: true,
    items: ['Credito', 'Al Contado'],
    permisosRuta: {},
    permisosCliente: {},
    notaE: [],
    cliente: null, // ver que hace esto
    vendedores: [],
    clientes: [],
    empresa: [],
    selectC: '',
    idClienteArray: [],
    nombreUsuario: '',
    editedIndex: -1,
    productosParaVenta: [],
    editedItem: {
      idPedido: '',
      numeroPedido: '',
      observacion: '',
      detalleProducto: [],
      fechaCreacion: '',
      fechaVencimiento: '',
      subTotal: 0,
      gravado: 0,
      exento: 0,
      baseImponible: 0,
      total: 0,
      debito: 0,
      credito: 0,
      tipoVenta: ''
    },
    defaultItem: {
      idPedido: '',
      numeroPedido: '',
      observacion: '',
      detalleProducto: [],
      fechaCreacion: '',
      fechaVencimiento: '',
      subTotal: 0,
      gravado: 0,
      exento: 0,
      baseImponible: 0,
      total: 0,
      debito: 0,
      credito: 0,
      tipoVenta: ''
    }
  }),

  components: {
    ProductosCargados,
    ProductosParaVenta,
    ClienteM,
    Factura
  },

  computed: {
    formTitle () {
      return this.read
        ? 'Informacion de nota de Entrega'
        : 'Facturar Nota de Entrega'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
    this.initialize2()
    // this.permisosRuta = this.$store.state.empresa[0].permisos.find(
    //   permiso => permiso.ruta == "NotaEntrega"
    // );
  },

  mounted () {
    this.consignado = true
  },

  methods: {
    initialize () {
      this.config.campoDiasCreditoCli = this.$store.state.config.campoDiasCreditoCli
      this.listarNotas()
      this.listarClientes()
      this.listarProductoParaVenta()
      this.buscarUsuario()
      this.permisosCliente = this.$store.state.empresa[0].permisos.find(
        permiso => permiso.ruta === 'Cliente'
      )
    },

    initialize2 () {
      this.cargarEmpresa(this.$store.state.empresa[0].idEmpresa._id)
    },

    listarNotas () {
      Api.get('notaEntrega')
        .then(res => {
          this.notaE = res.data
          console.log('NOTA', this.notaE)
          this.notaE.map(data => {
            data.fechaCreacion = this.formato(data.fechaCreacion)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarClientes () {
      Api.get('cliente')
        .then(res => {
          this.clientes = res.data
          this.clientes.map(data => {
            this.idClienteArray.push({ 
              text: data.nombre,
              value: data._id 
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarProductoParaVenta () {
      Api.get('proalma/soloVenta')
        .then(res => {
          this.loadinghijo = false
          this.productosParaVenta = res.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    buscarUsuario () {
      Api.get('usuario', this.$store.state.usuario._id)
        .then(res => {
          this.nombreUsuario = res.data[0].nombre
          this.editedItem.idUsuario = this.$store.state.usuario._id
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    cargarEmpresa (id) {
      Api.get(`empresa/${id}`).then(response => {
        this.empresa = response.data
      })
    },

    clienteSeleccionado (data) {
      const cli = this.clientes.find(cli => cli._id === data)
      this.editedItem.idCliente = cli
    },

    agregarAlCarrito (item) {
      const indexVenta = this.productosParaVenta.findIndex( prod => prod.idProducto === item.idProducto )
      const indexCarrito = this.editedItem.detalleProducto.findIndex( prod => prod.idProducto._id === item.idProducto._id )
      if (indexCarrito > -1) {
        this.editedItem.detalleProducto[indexCarrito].cantidadSolicitada += item.cantidadSolicitada
        this.editedItem.detalleProducto[indexCarrito].total += item.total
        this.editedItem.detalleProducto[indexCarrito].total = Math.round(this.editedItem.detalleProducto[indexCarrito].total * 100) / 100
        this.editedItem.detalleProducto = [...this.editedItem.detalleProducto]
      } else {
        this.editedItem.detalleProducto.push(item)
      }
      Object.assign(this.productosParaVenta[indexVenta], item)
      this.actualizarMontosTotales()
    },

    modificarCarrito (item) {
      const indexVenta = this.productosParaVenta.findIndex( prod => prod.idProducto._id === item.idProducto._id )
      item.cantidad = this.productosParaVenta[indexVenta].cantidad
      let producto = Object.assign({}, item)
      let suma = item.cantidad + item.cantidadSolicitada
      if (producto.cantidadSolicitadaAux > suma) {
        this.$swal({
          icon: 'error',
          title: 'La cantidad solicitada es mayor al stock',
          text: `cantidad solcitidad: ${producto.cantidadSolicitadaAux}, cantidad en stock: ${suma}`
        })
      } else {
        if (producto.cantidadSolicitadaAux < producto.cantidadSolicitada) {
          let dif = producto.cantidadSolicitada - producto.cantidadSolicitadaAux
          producto.cantidad += dif
          producto.cantidadSolicitada = producto.cantidadSolicitadaAux
        } else if (
          producto.cantidadSolicitadaAux === producto.cantidadSolicitada
        ) {
        } else {
          producto.cantidad -= producto.cantidadSolicitadaAux - producto.cantidadSolicitada
          producto.cantidadSolicitada = parseInt(producto.cantidadSolicitada)
        }
      }
      const indexCarrito = this.editedItem.detalleProducto.findIndex( prod => prod.idProducto._id === item.idProducto._id )
      Object.assign(this.editedItem.detalleProducto[indexCarrito], producto)
      Object.assign(this.productosParaVenta[indexVenta], item)
      this.editedItem.detalleProducto = [...this.editedItem.detalleProducto]
      this.productosParaVenta = [...this.productosParaVenta]
      this.actualizarMontosTotales()
    },

    quitarCarrito (item) {
      const pos = this.editedItem.detalleProducto.indexOf(item)
      const indexVenta = this.productosParaVenta.findIndex( prod => prod.idProducto._id === item.idProducto._id )
      this.editedItem.detalleProducto.splice(pos, 1)
      this.productosParaVenta[indexVenta].cantidad += item.cantidadSolicitada
      this.actualizarMontosTotales()
      if (this.editedItem.detalleProducto.length > 0) this.boton = false
    },

    actualizarMontosTotales () {
      // actualiza los montos totales cuando se agrega o se quita un producto
      this.editedItem.subTotal = 0
      this.editedItem.gravado = 0
      this.editedItem.baseImponible = 0
      this.editedItem.exento = 0
      this.editedItem.total = 0
      if (this.editedItem.detalleProducto.length > 0) {
        this.editedItem.detalleProducto.map(data => {
          this.editedItem.subTotal += data.subTotal
          this.editedItem.gravado += data.gravado
          this.editedItem.baseImponible += data.baseImponible
          this.editedItem.exento += data.exento
        })
        this.editedItem.total = Math.round((this.editedItem.subTotal + this.editedItem.gravado) * 100) / 100
      }
    },

    formato (fecha) {
      return fecha.substr(0, 10)
    },

    validarCrear () {
      return true
      // return this.permisosRuta.accion.includes("Crear");
    },
    validarModificar () {
      return true
      // return this.permisosRuta.accion.includes("Modificar");
    },
    validarEliminar () {
      return true
      // return this.permisosRuta.accion.includes("Eliminar");
    },
    validarCrearCli () {
      return this.permisosCliente?.accion.includes('Crear')
    },

    editItem (item, bool) {
      this.dialog = true
      this.read = bool
      this.editedIndex = this.notaE.indexOf(item)
      this.editedItem = Object.assign({}, item)
      if (!this.editedItem.idPedido) {
        this.editedItem.idPedido = { numeroPedido: null }
        this.cliente = item.idCliente.nombre
        for (let producto of this.editedItem.detalleProducto) {
          if (!producto.despachada) {
            producto.despachada = producto.cantidadSolicitada
          }
        }
      } else this.cliente = item.idPedido.idCliente.nombre
      console.log(item)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.editedItem.detalleProducto = []
        this.cliente = null
        this.read = false
      }, 300)
    },

    closeF () {
      this.dialogFactura = false
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    validarCampos () {
      if (this.editedIndex > -1) {
        if (!this.editedItem.tipoVenta) {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor llene todos los campos para continuar'
          })
          this.boton = false
          return true
        }
        if (!this.config.campoDiasCreditoCli) {
          if (!this.editedItem.fechaVencimiento) {
            this.$swal({
              icon: 'error',
              title: 'Formulario incompleto',
              text: 'Por favor llene todos los campos para continuar'
            })
            this.boton = false
            return true
          }
        }
        if (this.editedItem.observacion === '') {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor debe agregar una observación a la factura'
          })
          this.boton = false
          return true
        }
      } else {
        if (!this.editedItem.idCliente) {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor debe agregar un Cliente'
          })
          return true
        }
        if (!this.editedItem.tipoVenta) {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor llene todos los campos para continuar'
          })
          return true
        }
        if (this.editedItem.fechaCreacion === '') {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor debe agregar una fecha de creación'
          })
          return true
        }
        if (this.editedItem.observacion === '') {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor debe agregar una observación a la factura'
          })
          return true
        }
        if (this.editedItem.detalleProducto.length === 0) {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor debe agregar productos a la Nota'
          })
          return true
        }
      }
      return false
    },

    save () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })

        delete this.editedItem.estatus
        this.editedItem.idPedido = this.editedItem._id
        this.editedItem.tipo = 'nota_entrega'
        this.editedItem.debito = 0
        this.editedItem.credito = this.editedItem.total

        if (this.editedIndex === -1) {
          this.origen = 'nota'
          Api.post('notaEntrega', this.editedItem)
            .then(res => {
              this.editedItem.numFactura = 0
              this.editedItem.numControl = res.data.numNotaEntrega
              this.listarNotas()
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              let array = {
                editedItem: this.editedItem,
                nombreUsuario: this.nombreUsuario,
                condicion: 'notaEntregaDirecta',
                empresa: this.empresa
              }
              // Bus a Factura.vue
              EventBus.$emit('dataFactura', array)
              this.dialogFactura = true
              this.close()
              this.initialize2()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        } else {
          this.origen = 'factura'
          Api.post('venta', this.editedItem)
            .then(res => {
              if (!this.editedItem.idPedido) {
                this.editedItem.idPedido = { numeroPedido: null }
              }
              this.editedItem.numFactura = res.data.numFactura
              this.editedItem.numControl = res.data.numControl
              this.listarNotas()
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              let array = {
                editedItem: this.editedItem,
                nombreUsuario: this.nombreUsuario,
                condicion: 'facturaDirecta',
                empresa: this.empresa
              }
              // Bus a Factura.vue
              EventBus.$emit('dataFactura', array)
              this.dialogFactura = true
              this.close()
              this.initialize2()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    }
  }
}
</script>
